import { useRef, useState } from 'react'
import Image from '@ui/image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/pro-regular-svg-icons/faFilePdf'
import FlipBook from '@components/flipbook/layout-01'
import { Container, Row, Col } from '@ui/wrapper'
import {
  BoxImgWrapper,
  BoxImgInner,
  BoxImgMedia,
  BoxImgContent,
  BoxImgText,
  Break,
  HeadingWrap,
  HeadingWrap2,
  TextWrap
} from './style'
import usePdfData from '@hooks/use-pdf-data'

const BoxImage = ({
  children,
  image,
  imageWidth,
  name,
  title,
  desc,
  path,
  icon,
  className,
  openInFlipbook = false,
  showTitle = true,
  leftCol = 3,
  rightCol = 9,
  ...restProps
}) => {
  const [rerender, setRerender] = useState(0)
  const bookRef = useRef(null)
  const pdfData = usePdfData(path)

  const showPdfData = openInFlipbook ? pdfData : null
  icon = showPdfData ? icon : faFilePdf

  return (
    <BoxImgWrapper className={className} {...restProps}>
      <BoxImgInner>
        <Container>
          <Row alignItems="center">
            {image?.src && (
              <Col
                lg={leftCol}
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <BoxImgMedia width={imageWidth}>
                  <span
                    onClick={() => {
                      if (showPdfData) {
                        bookRef.current?.setShow(true)
                      } else if (path) {
                        window.open(path, '_blank')
                      }
                    }}
                    style={{ cursor: path || pdfData ? 'pointer' : 'default' }}
                  >
                    <Image
                      src={image.src.localFile || image.src}
                      alt={image.src.alternativeText || title}
                    />
                  </span>
                  {name && (
                    <>
                      <Break />
                      <BoxImgText>{name}</BoxImgText>
                    </>
                  )}
                </BoxImgMedia>
              </Col>
            )}
            <Col lg={rightCol}>
              <BoxImgContent>
                {title && showTitle && <HeadingWrap>{title}</HeadingWrap>}
                {desc && (
                  <TextWrap
                    dangerouslySetInnerHTML={{
                      __html: desc
                    }}
                  />
                )}
                {children}
                <HeadingWrap2>
                  {(pdfData && (
                    <span
                      onClick={() => {
                        bookRef.current?.setShow(true)
                      }}
                    >
                      {icon && (
                        <FontAwesomeIcon
                          icon={icon}
                          style={{ marginRight: '10px' }}
                        />
                      )}
                      {title}
                    </span>
                  )) || (
                    <a href={path}>
                      {icon && (
                        <FontAwesomeIcon
                          icon={icon}
                          style={{ marginRight: '10px' }}
                        />
                      )}
                      {title}
                    </a>
                  )}
                </HeadingWrap2>
              </BoxImgContent>
            </Col>
          </Row>
          {pdfData && (
            <FlipBook
              key={rerender}
              ref={bookRef}
              pdfFile={pdfData}
              url={path}
              resetFlipBook={() => setRerender((prev) => prev + 1)}
              allowDownload={restProps.allowDownload !== false}
            />
          )}
        </Container>
      </BoxImgInner>
    </BoxImgWrapper>
  )
}

export default BoxImage
